import {UiEvent, UiEventType} from '@web/middlewares/uiLogging'

export const nClicksMap = new Map<UiEventType, [string, string]>([
    [UiEvent.POINT_PAYMENT_OPEN_TOOLTIP, ['fmp.pointinfo', 'fmp.pointinfo']],
    [UiEvent.POINT_PAYMENT_INPUT_BLUR, ['fmp.point', 'fmp.point']],
    [UiEvent.POINT_PAYMENT_INPUT_CLEAR, ['fmp.clearpoi', 'fmp.clearpoi']],
    [UiEvent.POINT_PAYMENT_USE_ALL, ['fmp.allpoi', 'fmp.allpoi']],
    [UiEvent.POINT_PAYMENT_USE_ALL_ON, ['fmp.alwaysallpoi', 'fmp.alwaysallpoi']],
    [UiEvent.POINT_PAYMENT_USE_ALL_OFF, ['fmp.noalwallpoi', 'fmp.noalwallpoi']],
    [UiEvent.POINT_PAYMENT_SHOW_AFFILIATE_POINT, ['fmp.pointswap', 'fmp.pointswap']],
    [UiEvent.POINT_PAYMENT_SHOW_AFFILIATE_POINT_FIND, ['fmp.pntcheck', 'fmp.pntcheck']],
    [UiEvent.POINT_PAYMENT_PAY_LATER_JOIN, ['fmp.joinpaylater', 'fmp.joinpaylater']],
    [UiEvent.POINT_PAYMENT_PAY_LATER_USE_ON, ['fmp.onpaylater', 'fmp.onpaylater']],
    [UiEvent.POINT_PAYMENT_PAY_LATER_USE_OFF, ['fmp.offpaylater', 'fmp.offpaylater']],
    [UiEvent.POINT_PAYMENT_PAY_LATER_INPUT_CLEAR, ['fmp.clearpaylater', 'fmp.clearpaylater']],
    [UiEvent.POINT_PAYMENT_PAY_LATER_REDEEM, ['fmp.paylateroverduepaynow', 'fmp.paylateroverduepaynow']],
    [UiEvent.POINT_PAYMENT_PAY_LATER_USE_ALL, ['fmp.allpaylater', 'fmp.allpaylater']],
    [UiEvent.PAYMENT_METHOD_NOTICE, ['fmp.eventtext', 'fmp.eventtext']],
    [UiEvent.PAYMENT_METHOD_CONNECT_RECHARGING_ACCOUNT, ['fmp.addaccount', 'fmp.addaccount']],
    [UiEvent.PAYMENT_METHOD_TITLE, ['fmp.payinfo', 'fmp.payinfo']],
    [UiEvent.PAYMENT_METHOD_PAYMONEY_ON, ['fmp.chargepointon', 'fmp.chargepointon']],
    [UiEvent.PAYMENT_METHOD_COMPLEX_PAYMONEY_PAYMENT_OFF, ['fmp.chargepointoff', 'fmp.chargepointoff']],
    [UiEvent.PAYMENT_METHOD_RECHARGING_POINT_ON, ['fmp.chargepointon', 'fmp.chargepointon']],
    [UiEvent.PAYMENT_METHOD_COMPLEX_PAYMENT_OFF, ['fmp.chargepointoff', 'fmp.chargepointoff']],
    [UiEvent.PAYMENT_METHOD_PAYMONEY_AMOUNT, ['fmp.chargepointamount', 'fmp.chargepointamount']],
    [UiEvent.PAYMENT_METHOD_PAYMONEY_ACCOUNT, ['fmp.chargeaccount', 'fmp.chargeaccount']],
    [UiEvent.PAYMENT_METHOD_RECHARGING_AMOUNT, ['fmp.chargepointamount', 'fmp.chargepointamount']],
    [UiEvent.PAYMENT_METHOD_RECHARGING_ACCOUNT, ['fmp.chargeaccount', 'fmp.chargeaccount']],
    [
        UiEvent.PAYMENT_METHOD_ADD_PAYMONEY_RECHARGING_ACCOUNT,
        ['fmp.chargepointaccountadd', 'fmp.chargepointaccountadd'],
    ],
    [UiEvent.PAYMENT_METHOD_RECHARGE_PROMOTION_BANNER, ['fmp.chargepointguidebanner', 'fmp.chargepointguidebanner']],
    [UiEvent.PAYMENT_METHOD_EASY_ACCOUNT_ON, ['fmp.simpleaccount', 'fmp.simpleaccount']],
    [UiEvent.PAYMENT_METHOD_ADD_EASY_ACCOUNT, ['fmp.addsimacc', 'fmp.addsimacc']],
    [UiEvent.PAYMENT_METHOD_SWIPE_EASY_ACCOUNT, ['fmp.simaccswipe', 'fmp.simaccswipe']],
    [UiEvent.PAYMENT_METHOD_EASY_CARD_ON, ['fmp.simplecard', 'fmp.simplecard']],
    [UiEvent.PAYMENT_METHOD_SWIPE_EASY_CARD, ['fmp.simcardswipe', 'fmp.simcardswipe']],
    [UiEvent.PAYMENT_METHOD_ADD_EASY_CARD, ['fmp.addsimcard', 'fmp.addsimcard']],
    [UiEvent.PAYMENT_METHOD_NORMAL_PAY_ON, ['fmp.paygeneral', 'fmp.paygeneral']],
    [UiEvent.PAYMENT_METHOD_FAMILY_PAY_ON, ['fmp.familypay', 'fmp.familypay']],
    [UiEvent.PAYMENT_METHOD_FAMILY_PAY_MESSAGE_ON, ['fmp.familypaymessage', 'fmp.familypaymessage']],
    [UiEvent.PAYMENT_METHOD_FAMILY_PAY_TOOLTIP_ON, ['fmp.familypayinfo', 'fmp.familypayinfo']],
    [UiEvent.PAYMENT_METHOD_CREDIT_CARD_ON, ['fmp.card', 'fmp.card']],
    [UiEvent.PAYMENT_METHOD_MOBILE_ON, ['fmp.cellphone', 'fmp.cellphone']],
    [UiEvent.PAYMENT_METHOD_PAY_NEXT_ON, ['fmp.deposit', 'fmp.deposit']],
    // 삼성페이가 없음 확인 필요
    [UiEvent.PAYMENT_METHOD_SAMSUNG_PAY_ON, ['fmp.samsungpay', 'fmp.samsungpay']],
    [UiEvent.PAYMENT_METHOD_PAY_LATER_BANNER, ['fmp.cellphonepaylaterbanner', 'fmp.cellphonepaylaterbanner']],
    [UiEvent.PAYMENT_METHOD_PAY_NEXT_SELECT_ON, ['fmp.ploption', 'fmp.ploption']],
    [UiEvent.PAYMENT_METHOD_PAY_NEXT_TOOLTIP, ['fmp.plmean', 'fmp.plmean']],
    [UiEvent.PAYMENT_METHOD_PAY_NEXT_TIMELINE, ['fmp.timeline', 'fmp.timeline']],
    [UiEvent.PAYMENT_METHOD_PAY_NEXT_ADD_ACCOUNT, ['fmp.adspaccount', 'fmp.adspaccount']],
    [UiEvent.PAYMENT_METHOD_PAY_NEXT_ADD_CARD, ['fmp.adspcard', 'fmp.adspcard']],
    [UiEvent.PAYMENT_METHOD_ADD_RECHARGING_ACCOUNT, ['fmp.chargepointaccountadd', 'fmp.chargepointaccountadd']],
    [UiEvent.PAYMENT_METHOD_VIRTUAL_ACCOUNT_TOOLTIP_CLOSE, ['fmp.closelayer', 'fmp.closelayer']],
    [UiEvent.PAYMENT_METHOD_VIRTUAL_ACCOUNT_TOOLTIP_BUTTON, ['fmp.placcount', 'fmp.placcount']],
    [UiEvent.PAYMENT_METHOD_VIRTUAL_ACCOUNT_TOOLTIP_WEEK_CLOSE, ['fmp.nolayer', 'fmp.nolayer']],
    [
        UiEvent.PAYMENT_METHOD_SAMSUNG_PAY_PAY_MONEY_BANNER,
        ['fmp.general_chargepoint_samsungpay', 'fmp.general_chargepoint_samsungpay'],
    ],
    [UiEvent.PAYMENT_METHOD_NO_PAYMENT, ['fmp.paymentdimm', 'fmp.paymentdimm']],
    [UiEvent.PAYMENT_METHOD_BENEFIT_INFO, ['fmp.paybenefitinfo', 'fmp.paybenefitinfo']],
    [UiEvent.PAYLATER_OVERDUE_REDEEM, ['fmp.paylateroverdue', 'fmp.paylateroverdue']],
    [UiEvent.PAYLATER_OVERDUE_CLOSE, ['fmp.paylateroverdueclose', 'fmp.paylateroverdueclose']],
    [UiEvent.ACCUMULATE_POINT_TOGGLE_BENEFIT_TOOLTIP, ['fmp.beneinfo', 'fmp.beneinfo']],
    [UiEvent.ACCUMULATE_POINT_TOGGLE_MEMBERSHIP_BENEFIT_TOOLTIP, ['fmp.membershiphelp', 'fmp.membershiphelp']],
    [UiEvent.ACCUMULATE_POINT_OPEN_REVIEW_TOOLTIP, ['fmp.revinfo', 'fmp.revinfo']],
    [UiEvent.ACCUMULATE_POINT_MEMBERSHIP_LINE_BANNER, ['fmp.membershiplinebanner', 'fmp.membershiplinebanner']],
    [
        UiEvent.ACCUMULATE_POINT_MEMBERSHIP_REJOIN_LINE_BANNER,
        ['fmp.rejoinmembershiplinebanner', 'fmp.rejoinmembershiplinebanner'],
    ],
    [
        UiEvent.ACCUMULATE_POINT_MEMBERSHIP_POPUP_BUTTON,
        ['fmp.membershiplinebannerapply', 'fmp.membershiplinebannerapply'],
    ],
    [UiEvent.ACCUMULATE_POINT_FAMILY_PAY_TOOLTIP_ON, ['fmp.familypaypointinfo', 'fmp.familypaypointinfo']],
    [UiEvent.ACCUMULATE_POINT_FAMILY_PAY_TOOLTIP_OFF, ['fmp.familypaypointinfox', 'fmp.familypaypointinfox']],

    [UiEvent.PAYMENT_METHOD_REGIST_FIRST_EASY_PAYMENT_METHOD, ['fmp.firstsimplepay', 'fmp.firstsimplepay']],
    [UiEvent.PAYMENT_METHOD_REGIST_FIRST_EASY_CARD, ['fmp.firstsimplecard', 'fmp.firstsimplecard']],
    [UiEvent.PAYMENT_METHOD_REGIST_FIRST_EASY_BANK, ['fmp.firstsimpleaccount', 'fmp.firstsimpleaccount']],
    [UiEvent.APPROVAL_FAIL_REORDER, ['fle.orderagain', 'fle.orderagain']],
    [UiEvent.APPROVAL_FAIL_GO_SHOPPING_HOME, ['fle.shophome', 'fle.shophome']],
    [UiEvent.APPROVAL_FAIL_PAYLATER_USE_BANNER_SHOW, ['fle.plmemapp', 'fle.plmemapp']],
    [UiEvent.APPROVAL_FAIL_PAYLATER_USE_BANNER_CLICK, ['fle.plmemclick', 'fle.plmemclick']],
    [UiEvent.APPROVAL_FAIL_PAYLATER_JOIN_BANNER_SHOW, ['fle.pljoinapp', 'fle.pljoinapp']],
    [UiEvent.APPROVAL_FAIL_PAYLATER_JOIN_BANNER_CLICK, ['fle.pljoinclick', 'fle.pljoinclick']],
    [UiEvent.HYUNDAI_FOCUSING_INDUCTION_BANNER_CLICK, ['fmp.nhdcintro', 'fmp.nhdcintro']],
    [UiEvent.HYUNDAI_CARD_TYPE_BANNER_CLICK, ['fmp.nhdcplate', 'fmp.nhdcplate']],
    [UiEvent.HYUNDAI_GET_BENEFIT_NOW_CLICK, ['fmp.nhdcbenefit', 'fmp.nhdcbenefit']],
    [UiEvent.SAMSUNG_TAPTAP_FOCUSING_INDUCTION_BANNER_CLICK, ['fmp.ssttintro', 'fmp.ssttintro']],
    [UiEvent.SAMSUNG_TAPTAP_CARD_TYPE_BANNER_CLICK, ['fmp.ssttplate', 'fmp.ssttplate']],
    [UiEvent.SAMSUNG_TAPTAP_GET_BENEFIT_NOW_CLICK, ['fmp.ssttbenefit', 'fmp.ssttbenefit']],
    [UiEvent.NAVERPAY_MONEY_FOCUSING_INDUCTION_BANNER_CLICK, ['fmp.npmcintro', 'fmp.npmcintro']],
    [UiEvent.NAVERPAY_MONEY_CARD_TYPE_BANNER_CLICK, ['fmp.npmcplate', 'fmp.npmcplate']],
    [UiEvent.NAVERPAY_MONEY_GET_BENEFIT_NOW_CLICK, ['fmp.npmcbenefit', 'fmp.npmcbenefit']],
    [UiEvent.PROMOTION_HYUNDAI_FOCUSING_INDUCTION_BANNER_CLICK, ['fmp.nhdcintrocardpm', 'fmp.nhdcintrocardpm']],
    [UiEvent.PROMOTION_HYUNDAI_CARD_TYPE_BANNER_CLICK, ['fmp.nhdcplatecardpm', 'fmp.nhdcplatecardpm']],
    [UiEvent.PROMOTION_HYUNDAI_GET_BENEFIT_NOW_CLICK, ['fmp.nhdcbenefitcardpm', 'fmp.nhdcbenefitcardpm']],
    [UiEvent.PROMOTION_LOTTE_FOCUSING_INDUCTION_BANNER_CLICK, ['fmp.splcintrocardpm', 'fmp.splcintrocardpm']],
    [UiEvent.PROMOTION_LOTTE_CARD_TYPE_BANNER_CLICK, ['fmp.splcplatecardpm', 'fmp.splcplatecardpm']],
    [UiEvent.PROMOTION_LOTTE_GET_BENEFIT_NOW_CLICK, ['fmp.splcbenefitcardpm', 'fmp.splcbenefitcardpm']],
    [UiEvent.PROMOTION_SHINHAN_FOCUSING_INDUCTION_BANNER_CLICK, ['fmp.shlfintrocardpm', 'fmp.shlfintrocardpm']],
    [UiEvent.PROMOTION_SHINHAN_CARD_TYPE_BANNER_CLICK, ['fmp.shlfplatecardpm', 'fmp.shlfplatecardpm']],
    [UiEvent.PROMOTION_SHINHAN_GET_BENEFIT_NOW_CLICK, ['fmp.shlfbenefitcardpm', 'fmp.shlfbenefitcardpm']],
    [UiEvent.PROMOTION_SAMSUNG_FOCUSING_INDUCTION_BANNER_CLICK, ['fmp.ssttintrocardpm', 'fmp.ssttintrocardpm']],
    [UiEvent.PROMOTION_SAMSUNG_CARD_TYPE_BANNER_CLICK, ['fmp.ssttplatecardpm', 'fmp.ssttplatecardpm']],
    [UiEvent.PROMOTION_SAMSUNG_GET_BENEFIT_NOW_CLICK, ['fmp.ssttbenefitcardpm', 'fmp.ssttbenefitcardpm']],
    [
        UiEvent.PROMOTION_KOOKMIN_HAPPINESS_SAMSUNG_FOCUSING_INDUCTION_BANNER_CLICK,
        ['fmp.sskhintrocardpm', 'fmp.sskhintrocardpm'],
    ],
    [UiEvent.PROMOTION_KOOKMIN_HAPPINESS_SAMSUNG_BANNER_CLICK, ['fmp.sskhplatecardpm', 'fmp.sskhplatecardpm']],
    [
        UiEvent.PROMOTION_KOOKMIN_HAPPINESS_SAMSUNG_GET_BENEFIT_NOW_CLICK,
        ['fmp.sskhbenefitcardpm', 'fmp.sskhbenefitcardpm'],
    ],
    /** @deprecated UI 개선 */
    [UiEvent.SHINHAN_LINE_FRIENDS_FOCUSING_INDUCTION_BANNER_CLICK, ['fmp.shlfintro', 'fmp.shlfintro']],
    [UiEvent.SHINHAN_LINE_FRIENDS_CARD_TYPE_BANNER_CLICK, ['fmp.shlfplate', 'fmp.shlfplate']],
    [UiEvent.SHINHAN_LINE_FRIENDS_GET_BENEFIT_NOW_CLICK, ['fmp.shlfbenefit', 'fmp.shlfbenefit']],
    [UiEvent.LOTTE_NPAY_LOCA_FOCUSING_INDUCTION_BANNER_CLICK, ['fmp.splcintro', 'fmp.splcintro']],
    [UiEvent.LOTTE_NPAY_LOCA_CARD_TYPE_BANNER_CLICK, ['fmp.splcplate', 'fmp.splcplate']],
    [UiEvent.LOTTE_NPAY_LOCA_GET_BENEFIT_NOW_CLICK, ['fmp.splcbenefit', 'fmp.splcbenefit']],
    /** 결제 FE 유효성검증 */
    [UiEvent.DELIVERY_INPUT_FAIL, ['fmp.addrnone', 'fmp.addrnone']],
    [UiEvent.DELIVERY_ADDRESS_NAME_MAX_FAIL, ['fmp.delnameover', 'fmp.delnameover']],
    [UiEvent.DELIVERY_RECEIVER_NAME_FAIL, ['fmp.addrnamenone', 'fmp.addrnamenone']],
    [UiEvent.DELIVERY_RECEIVER_NAME_MAX_FAIL, ['fmp.addrnameover', 'fmp.addrnameover']],
    [UiEvent.DELIVERY_DETAIL_ADDRESS_MAX_FAIL, ['fmp.addrdtlover', 'fmp.addrdtlover']],
    [UiEvent.DELIVERY_PHONE_NUMBER_FAIL, ['fmp.addrphonediff1', 'fmp.addrphonediff1']],
    [UiEvent.DELIVERY_PHONE_NUMBER_TWO_FAIL, ['fmp.addrphonediff2', 'fmp.addrphonediff2']],
    [UiEvent.DELIVERY_KOREA_ADDRESS_FAIL, ['fmp.addrchar', 'fmp.addrchar']],
    [UiEvent.DELIVERY_LOT_DETAIL_NONE, ['fmp.jibundtlnone', 'fmp.jibundtlnone']],
    [UiEvent.PERSONAL_CUSTOMS_CODE_FAIL, ['fmp.cuscodeerr', 'fmp.cuscodeerr']],
    [UiEvent.RECEIVER_NAME_FAIL, ['fmp.recnamenone', 'fmp.recnamenone']],
    [UiEvent.RECEIVER_PHONE_NUMBER_FAIL, ['fmp.recphonediff', 'fmp.recphonediff']],
    [UiEvent.MEMO_MAX_FAIL, ['fmp.memoover', 'fmp.memoover']],
    [UiEvent.CASH_RECEIPT_PHONE_NUMBER_FAIL, ['fmp.recephoneerr', 'fmp.recephoneerr']],
    [UiEvent.CASH_RECEIPT_CARD_FAIL, ['fmp.rececarderr', 'fmp.rececarderr']],
    [UiEvent.CASH_RECEIPT_BUSINESS_REGISTRATION, ['fmp.recebuserr', 'fmp.recebuserr']],
    [UiEvent.PAY_MONEY_USING_FAIL, ['fmp.chrpoierr', 'fmp.chrpoierr']],
    [UiEvent.PAY_MONEY_DELETED, ['fmp.paymoneyerr', 'fmp.paymoneyerr']],
    [UiEvent.UNAVAILABLE_CHARGE_BANK, ['fmp.chrpoitallins', 'fmp.chrpoitallins']],
    [UiEvent.UNAVAILABLE_CHARGE_BANK_ACCOUNT, ['fmp.chrpointaccins', 'fmp.chrpointaccins']],
    [UiEvent.EMPTY_CHARGE_BANK, ['fmp.chrpointaccnone', 'fmp.chrpointaccnone']],
    [UiEvent.NONE_SELECTED_PAY_METHOD, ['fmp.paynone', 'fmp.paynone']],
    [UiEvent.EMPTY_EASY_CARD, ['fmp.simplecardnone', 'fmp.simplecardnone']],
    [UiEvent.EMPTY_EASY_BANK, ['fmp.simpleaccnone', 'fmp.simpleaccnone']],
    [UiEvent.UNAVAILABLE_EASY_BANK, ['fmp.simpleaccins', 'fmp.simpleaccins']],
    [UiEvent.NEED_CARD_CODE, ['fmp.cardnone', 'fmp.cardnone']],
    [UiEvent.CANT_USE_CARD, ['fmp.carderr', 'fmp.carderr']],
    [UiEvent.MOBILE_PHONE_NUMBER_FAIL, ['fmp.cellphoneerr', 'fmp.cellphoneerr']],
    [UiEvent.NEED_MOBILE_PASSWORD, ['fmp.simcppwerr', 'fmp.simcppwerr']],
    [UiEvent.VIRTUAL_ACCOUNT_BANK_CODE_FAIL, ['fmp.banknone', 'fmp.banknone']],
    [UiEvent.REFUND_ACCOUNT_CODE_FAIL, ['fmp.bankrefnone', 'fmp.bankrefnone']],
    [UiEvent.MINIMUM_MAXIMUM_AMOUNT_FAIL, ['fmp.payinfoerr', 'fmp.payinfoerr']],
    [UiEvent.MINIMUM_AMOUNT_FAIL, ['fmp.minpayerr', 'fmp.minpayerr']],
    [UiEvent.MAXIMUM_AMOUNT_FAIL, ['fmp.maxpayerr', 'fmp.maxpayerr']],
    [UiEvent.MAXIMUM_AMOUNT_FAIL_WITH_VIRTUAL_ACCOUNT_BANK, ['fmp.accountover', 'fmp.accountover']],
    [UiEvent.SELECT_ADDITIONAL_PAY_METHOD, ['fmp.complexnone', 'fmp.complexnone']],
    [UiEvent.FDS_PAYMENT_SECURITY, ['fmp.paylimit', 'fmp.paylimit']],
    [UiEvent.BLACK_CONSUMER, ['fmp.blackconsumer', 'fmp.blackconsumer']],
    [UiEvent.OPEN_BANKING_AGREED, ['fmp.agrbanknone', 'fmp.agrbanknone']],
    [UiEvent.AGREEMENT_THIRD_PEOPLE, ['fmp.agrinfonone', 'fmp.agrinfonone']],
    [UiEvent.AGREEMENT_CUSTOM_ORDER, ['fmp.agrcusnone', 'fmp.agrcusnone']],
    [UiEvent.AGREEMENT_PRE_ORDER, ['fmp.agrresnone', 'fmp.agrresnone']],
    [UiEvent.AGREEMENT_PERSONAL_DATA_CROSS_BORDER_TRANSFER, ['fmp.agrseanone', 'fmp.agrseanone']],
    [UiEvent.OVER_USING_AMOUNT, ['fmp.usepoiover', 'fmp.usepoiover']],
    [UiEvent.OVER_USING_REWARD_AMOUNT, ['fmp.usebepoiover', 'fmp.usebepoiover']],
    [UiEvent.OVER_USING_CHARGE_AMOUNT, ['fmp.usechrpoiover', 'fmp.usechrpoiover']],
    [UiEvent.OVER_PAY_LATER_AMOUNT, ['fmp.useplover', 'fmp.useplover']],
    [UiEvent.OVER_RECHARGING_AMOUNT, ['fmp.chrpoiover', 'fmp.chrpoiover']],
    [UiEvent.OUT_OF_STOCK, ['fmp.purchaseerr', 'fmp.purchaseerr']],
    [UiEvent.REGISTER_FIRST_EASY_PAYMENT, ['fmp.simpleerr', 'fmp.simpleerr']],
    [UiEvent.DEPRECATED_ZIPCODES, ['fmp.zipabol', 'fmp.zipabol']],
    [UiEvent.REJECT_SIX_DIGITS_ZIPCODE_WITH_ARRIVAL_GUARANTEE_PRODUCT, ['fmp.ziperr', 'fmp.ziperr']],
    [UiEvent.COMMON_ENTRANCE_PASSWORD_GUIDE, ['fmp.accmetdoornone', 'fmp.accmetdoornone']],
    [UiEvent.PICKUP_LOCATION_GUIDE, ['fmp.accesslocnone', 'fmp.accesslocnone']],
    [UiEvent.PICKUP_LOCATION_NAME_MAX_FAIL, ['fmp.accesslocover', 'fmp.accesslocover']],
    [UiEvent.ENTRY_METHOD_GUIDE, ['fmp.accmetetcnone', 'fmp.accmetetcnone']],
    [UiEvent.ENTRY_METHOD_NAME_MAX_FAIL, ['fmp.accmetetcover', 'fmp.accmetetcover']],
    [UiEvent.ADDITIONAL_OPTIONS_FAIL, ['fmp.optnone', 'fmp.optnone']],
    [UiEvent.DELIVERY_MEMO_SETTING_BUTTON, ['fmp.memosetting', 'fmp.memosetting']],
    [UiEvent.DELIVERY_MEMO_DELETE_BUTTON, ['fmp.memodelete', 'fmp.memodelete']],
    [UiEvent.DELIVERY_DELIVERY_INSTRUCTION_ADD_BUTTON, ['fmp.accessinput', 'fmp.accessinput']],
    [UiEvent.DELIVERY_DELIVERY_INSTRUCTION_MODIFY_BUTTON, ['fmp.accessedit', 'fmp.accessedit']],
    [UiEvent.DELIVERY_DELIVERY_INSTRUCTION_ALWAYS_USE_CHECKBOX, ['fmp.accessnext', 'fmp.accessnext']],
    [UiEvent.DELIVERY_DELIVERY_INSTRUCTION_CONFIRM_BUTTON, ['fmp.accessdone', 'fmp.accessdone']],
    [UiEvent.DELIVERY_INVALID_MODIFY_BUTTON, ['fmp.zipcodechange', 'fmp.zipcodechange']],

    /** 배너 클릭 이벤트 */
    [UiEvent.MEMBERSHIP_PLCC_BANNER_CLICK, ['fmp.nhdcorderapply2', 'fmp.nhdcorderapply2']],
    [UiEvent.SHINHAN_PARTNERSHIP_BANNER_CLICK, ['fmp.crecardlinebanner', 'fmp.crecardlinebanner']],
    /** 주문 실패 */
    [UiEvent.FAILURE_REORDER, ['fle.orderagain', 'fle.orderagain']],
    [UiEvent.FAILURE_GO_SHOPPING_HOME, ['fle.shophome', 'fle.shophome']],
    /** 대기열 */
    [UiEvent.WAITING_GO_BACK, ['fmp.waitingback', 'fmp.waitingback']],
])

export const resultNClicksMap = new Map<UiEventType, [string, string]>([
    [UiEvent.RESULT_LOGO, ['ctm.paylogo', 'ctm.paylogo']],
    [UiEvent.RESULT_HEADER_CART, ['ctm.gnbcart', 'ctm.gnbcart']],
    [UiEvent.RESULT_HEADER_SHOPPING_HOME, ['ctm.gnbshopping', 'ctm.gnbshopping']],
    [UiEvent.ECOUPON_BARCODE_INFO, ['ctm.barcode', 'ctm.barcode']],
    [UiEvent.VIRTUAL_ACCOUNT_NUMBER, ['ctm.copyaccountnumber', 'ctm.copyaccountnumber']],
    [UiEvent.DELIVERY_CHANGE, ['ctm.change', 'ctm.change']],
    [UiEvent.DELIVERY_MEMO_CHANGE_BUTTON, ['ctm.memoedit', 'ctm.memoedit']],
    [UiEvent.ORDER_LIST, ['ctm.orderlist', 'ctm.orderlist']],
    [UiEvent.ORDER_NO, ['ctm.orderno', 'ctm.orderno']],
    [UiEvent.ORDER_ITEM_OPEN, ['ctm.itemopen', 'ctm.itemopen']],
    [UiEvent.ORDER_ITEM_FOLD, ['ctm.itemfold', 'ctm.itemfold']],
    [UiEvent.ORDER_DETAIL, ['ctm.orderdetail', 'ctm.orderdetail']],
    [UiEvent.TIMELINE, ['ctm.timeline', 'ctm.timeline']],
    [UiEvent.PAY_NOW, ['ctm.pay', 'ctm.pay']],
    [UiEvent.ACCUMULATE_POINT_OPEN_REVIEW_TOOLTIP, ['ctm.revinfo', 'ctm.reviewbenefit']],
    [UiEvent.PRODUCT_NAME, ['ctm.image', 'ctm.product']],
    [UiEvent.PRODUCT_THUMBNAIL, ['ctm.name', 'ctm.product']],
    [UiEvent.SHOPPING_MALL_NAME, ['ctm.shoptext', 'ctm.shoptext']],
    [UiEvent.ORDER_LIST_BUTTON, ['ctm.orderlist', 'ctm.buylst']],
    [UiEvent.SHOPPING_HOME_BUTTON, ['ctm.home', 'ctm.home']],
    [UiEvent.GFD_BANNER_CLOSE, ['ctm.chrgebannerx', 'ctm.chrgebannerx']],
    [UiEvent.GFD_BANNER_WEEK_CLOSE, ['ctm.chrgebanner30x', 'ctm.chrgebanner30x']],
    /** 배송지 관리 */
    [UiEvent.RESULT_ADDRESS_BOOK_BACK_BUTTON, ['ctm.addrback', 'ctm.addrback']],
    [UiEvent.RESULT_ADDRESS_BOOK_ADD_BUTTON, ['ctm.addrnew', 'ctm.addrnew']],
    [UiEvent.RESULT_ADDRESS_BOOK_ADDRESS, ['ctm.addrselect', 'ctm.addrselect']],
    [UiEvent.RESULT_ADDRESS_BOOK_EDIT_BUTTON, ['ctm.addredit', 'ctm.addredit']],
    [UiEvent.RESULT_ADDRESS_BOOK_REGISTER_BUTTON, ['ctm.addrsave', 'ctm.addrsave']],
    [UiEvent.RESULT_ADDRESS_BOOK_DELETE_BUTTON, ['ctm.addrdelete', 'ctm.addrdelete']],
    [UiEvent.RESULT_ADDRESS_BOOK_SHOW_ALL_BUTTON, ['ctm.addrmore', 'ctm.addrmore']],
    [UiEvent.RESULT_ADDRESS_BOOK_CONFIRM_BUTTON, ['ctm.addrdone', 'ctm.addrdone']],
    [UiEvent.RESULT_ADDRESS_FORM_RECEIVER, ['ctm.addrname', 'ctm.addrname']],
    [UiEvent.RESULT_ADDRESS_FORM_PHONE_NUMBER, ['ctm.addrphone', 'ctm.addrphone']],
    [UiEvent.RESULT_ADDRESS_FORM_ADDITIONAL_PHONE_NUMBER, ['ctm.addrphoneadd', 'ctm.addrphoneadd']],
    [UiEvent.RESULT_ADDRESS_FORM_PRESET_HOME, ['ctm.addrpresethome', 'ctm.addrpresethome']],
    [UiEvent.RESULT_ADDRESS_FORM_PRESET_OFFICE, ['ctm.addrpresetoffice', 'ctm.addrpresetoffice']],
    [UiEvent.RESULT_ADDRESS_FORM_PRESET_SCHOOL, ['ctm.addrpresetschool', 'ctm.addrpresetschool']],
    [UiEvent.RESULT_ADDRESS_FORM_PRESET_FRIEND, ['ctm.addrpresetfriend', 'ctm.addrpresetfriend']],
    [UiEvent.RESULT_ADDRESS_FORM_PRESET_FAMILY, ['ctm.addrpresetfamily', 'ctm.addrpresetfamily']],
    [UiEvent.RESULT_ADDRESS_FORM_PRESET_MANUAL, ['ctm.addrpresetmanual', 'ctm.addrpresetmanual']],
    [UiEvent.RESULT_ADDRESS_FORM_SEARCH_ADDRESS, ['ctm.addrdelsearch', 'ctm.addrdelsearch']],
    [UiEvent.RESULT_ADDRESS_FORM_DETAIL_ADDRESS, ['ctm.addrdetail', 'ctm.addrdetail']],
    [UiEvent.RESULT_ADDRESS_FORM_SET_AS_PRIMARY_CHECKBOX, ['ctm.addrdefaultset', 'ctm.addrdefaultset']],
    [UiEvent.RESULT_ADDRESS_FORM_CONFIRM, ['ctm.addrcheck', 'ctm.addrcheck']],
    [UiEvent.RESULT_VIRTUAL_PHONE_NUMBER_CHECKBOX, ['ctm.safe', 'ctm.safe']],
    [UiEvent.RESULT_VIRTUAL_PHONE_NUMBER_INFO, ['ctm.safeinfo', 'ctm.safeinfo']],
    [UiEvent.RESULT_DELIVERY_MEMO_SELECT, ['ctm.click', 'ctm.click']],
    [UiEvent.RESULT_DELIVERY_MEMO_TEXTAREA, ['ctm.delmemo', 'ctm.delmemo']],
    [UiEvent.RESULT_DELIVERY_MEMO_REUSE_CHECKBOX, ['ctm.memosave', 'ctm.memosave']],
    /** 우편번호 검색 */
    [UiEvent.RESULT_ZIP_CODE_SEARCH_BUTTON, ['ctm.zipsearch', 'ctm.zipsearch']],
    [UiEvent.RESULT_ZIP_CODE_RESULT, ['ctm.zipselect', 'ctm.zipselect']],
    [UiEvent.RESULT_ZIP_CODE_RESULT_PAGINATION, ['ctm.zippage', 'ctm.zippage']],
    [UiEvent.DELIVERY_MEMO_DETAIL, ['ctm.seedelmemo', 'ctm.seedelmemo']],
    [UiEvent.ADDRESS_DELETE_CONFIRM_BUTTON, ['fmp.addrchkdelete', 'fmp.addrchkdelete']],
    [UiEvent.DELIVERY_VIRTUAL_PHONE_NUMBER_INFO_CLOSE_BUTTON, ['fmp.safeclose', 'fmp.safeclose']],
    [UiEvent.NO_CERTIFICATION_BANNER_TYPE_A, ['ctm.rightawayimgbanner', 'ctm.rightawayimgbanner']],
    [UiEvent.NO_CERTIFICATION_BANNER_TYPE_B, ['ctm.rightawaytextbanner', 'ctm.rightawaytextbanner']],
    /** 배너 */
    [UiEvent.MEMBERSHIP_GUIDE, ['ctm.membershipbanner3', 'ctm.membershipbanner3']],
    [UiEvent.MEMBERSHIP_ANNUAL_GUIDE, ['ctm.membershipbanner2', 'ctm.membershipbanner2']],
    [UiEvent.MEMBERSHIP_PROMOTION_GUIDE, ['ctm.membershipbanner1', 'ctm.membershipbanner1']],
    // 패밀리결제 유도 배너 멤버용
    [UiEvent.FAMILY_PAY_MEMBER, ['ctm.familypayformember', 'ctm.familypayformember']],
    // 패밀리결제 유도 배너 대표용
    [UiEvent.FAMILY_PAY_ORGANIZER, ['ctm.familypayfororganizer', 'ctm.familypayfororganizer']],
    // 패밀리결제 다시 알려주기
    [UiEvent.FAMILY_PAY_REQUEST, ['ctm.familypayrequest', 'ctm.familypayrequest']],
    // 공유하기_카톡
    [UiEvent.FAMILY_PAY_SHARE_KAKAO_TALK, ['ctm.fpsharekakaotalk', 'ctm.fpsharekakaotalk']],
    // 공유하기_문자
    [UiEvent.FAMILY_PAY_SHARE_SMS, ['ctm.fpsharesms', 'ctm.fpsharesms']],
    // 공유하기_톡톡
    [UiEvent.FAMILY_PAY_SHARE_TALK_TALK, ['ctm.fpsharetalktalk', 'ctm.fpsharetalktalk']],
    // 공유하기_닫기
    [UiEvent.FAMILY_PAY_SHARE_CLOSE, ['ctm.fpshareclose', 'ctm.fpshareclose']],
    // 공유하기_보내기
    [UiEvent.FAMILY_PAY_SHARE_CONFIRM, ['ctm.fpshareconfirm', 'ctm.fpshareconfirm']],
])
